import script from "./SystemDomainsView.vue?vue&type=script&lang=js"
export * from "./SystemDomainsView.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__